// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2xsyr","content":"ManualTimeModal_content__3YXus"};